export default __webpack_public_path__ + "static/media/image.d1279441.svg";